var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4934 58.8492C45.7821 58.8492 58.9867 45.6753 58.9867 29.4246C58.9867 13.1738 45.7821 0 29.4934 0C13.2046 0 0 13.1738 0 29.4246C0 45.6753 13.2046 58.8492 29.4934 58.8492Z",
    fill: "#8F2778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.105 27.9677L30.5071 26.9547C32.5378 25.4111 33.6498 24.1569 33.6498 22.2275C33.6498 20.4427 32.296 18.9956 29.9753 18.9956C27.6545 18.9956 25.8172 20.5874 25.6721 23.5781L25.5754 23.6263C23.8832 22.5169 20.4504 21.938 18.5164 22.4204L18.4197 22.3239C19.0482 16.6802 23.5931 12.3389 30.0236 12.3389C36.8409 12.3389 40.854 16.632 40.854 21.8898C40.854 26.1347 38.3398 28.7395 35.8256 30.7172L34.7619 31.5854C32.7312 33.129 32.4894 34.8173 32.4894 36.5538L32.3927 36.6503C30.6522 35.8303 27.316 35.8303 25.5754 36.6503L25.4787 36.5538C25.4787 32.9843 25.9622 30.3313 29.105 27.9677ZM29.0083 39.0139C31.4741 39.0139 33.3114 40.9434 33.3114 43.2106C33.3114 45.4777 31.4741 47.3589 29.0083 47.3589C26.5424 47.3589 24.7535 45.4777 24.7535 43.2106C24.7535 40.9434 26.5424 39.0139 29.0083 39.0139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84302 58.9073L16.3245 55.3023L6.45475 45.4556L2.84302 58.9073Z",
    fill: "#8F2778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.1f204aef42d97dc252e33c1788a9cf37.svg";
export { ForwardRef as ReactComponent };